// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowSuggestion-cls1_AJL","cls2":"BulkFollowSuggestion-cls2_PjW BulkFollowSuggestion-cls1_AJL"};